/**
 * Ausklapp-Funktion für Listings auf mobilen Geräten
 */
class ListingToggle {
    constructor(toggleButton) {
        toggleButton.addEventListener('click', () => ListingToggle.showAllListings(toggleButton));
    }

    static showAllListings(toggleButton) {
        const hiddenListings = document.querySelectorAll('.js-hidden-listing');
        const hiddenPagination = document.querySelector('.js-hidden-pagination');
        const hiddenSentinel = document.querySelector('.js-sentinel');
        const sidebar = document.querySelector('.js-sidebar');

        toggleButton.classList.add('is-hidden');

        if (hiddenPagination) {
            hiddenPagination.classList.remove('mobile-hidden-pagination');
        }

        if (hiddenSentinel) {
            hiddenSentinel.classList.remove('is-mobile-hidden');
        }

        if (sidebar) {
            sidebar.classList.add('is-hidden');
        }

        hiddenListings.forEach((listing) => {
            listing.classList.remove('listings__listing--hidden');
        });
    }
}

/**
 * Sortieren und Filtern von Listings
 */
class ListingSelectSubmit {
    constructor(select) {
        select.addEventListener('change', () => ListingSelectSubmit.submitForm(select));
    }

    static submitForm(select) {
        const form = select.parentNode.parentNode;
        form.submit();
    }
}

class ListingRangeChange {
    constructor(slider) {
        slider.addEventListener('input', () => ListingRangeChange.updateInputs(slider));
        // "ghost"-Slider braucht auch einen Eventlistener
        slider.nextElementSibling.addEventListener('input', () => ListingRangeChange.updateInputs(slider));
    }

    static updateInputs(slider) {
        const form = slider.parentNode.parentNode;
        const minPreisInput = form.querySelector('.js-price-range-min');
        const maxPreisInput = form.querySelector('.js-price-range-max');

        minPreisInput.value = slider.valueLow;
        maxPreisInput.value = slider.valueHigh;
    }
}

const listingFunctions = {
    init() {
        const toggleButton = document.querySelector('.js-listing-toggle');
        const listingSelectSubmits = document.querySelectorAll('.js-listing-select-submit');
        const listingRangeChange = document.querySelectorAll('.js-price-range.original');

        if (toggleButton) {
            // eslint-disable-next-line no-new
            new ListingToggle(toggleButton);
        }

        if (listingSelectSubmits) {
            listingSelectSubmits.forEach((select) => {
                // eslint-disable-next-line no-new
                new ListingSelectSubmit(select);
            });
        }

        if (listingRangeChange) {
            listingRangeChange.forEach((slider) => {
                // eslint-disable-next-line no-new
                new ListingRangeChange(slider);
            });
        }
    },
};

export default listingFunctions;
